import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
  firstTour: true,
  showOnboardingProgress: false,
  recognition: {
    infoCardsActive: false
  },
  automation: {
    infoCardsActive: false
  }
};

let store = set => ({
  ...initialState,
  handleOnboardingProgress: value => {
    set({ showOnboardingProgress: value });
  },
  updateFirstTour: value => {
    set({ showOnboardingProgress: value });
  },
  updateTourProgress: data => {
    set({
      [data.featureType]: {
        infoCardsActive: data.infoCardsActive
      }
    });
  },
  reset: () => set(initialState)
});

store = persist(store, {
  name: 'onboarding-store',
  storage: createJSONStorage(() => sessionStorage)
});
export const useOnboardingStore = create(devtools(store));
